import React from "react";
import { HelpCircle } from "lucide-react";
import { useLanguage } from "../i18n/LanguageContext";

export const FAQ = () => {
  const { t, tRaw } = useLanguage();
  const items = tRaw("faq.items") || [];
  const onboarding = tRaw("faq.onboarding");
  return (
    <section id="ukk" data-testid="faq-section" className="relative py-24 md:py-32 border-t-2 border-[#1a1a1a] grain">
      <div className="absolute top-8 left-5 md:left-10 font-mono text-[10px] tracking-[0.3em] text-[#A3A3A3] uppercase">{t("faq.section_number")}</div>
      <div className="absolute top-8 right-5 md:right-10 font-mono text-[10px] tracking-[0.3em] text-[#FFEA00] uppercase">Vastaukset · Selkeästi</div>

      <div className="max-w-[1200px] mx-auto px-5 md:px-10">
        <div className="text-center mb-14">
          <div className="inline-flex items-center gap-2 mb-4 px-3 py-1.5 border-2 border-[#FFEA00]/40 bg-black">
            <HelpCircle className="w-3.5 h-3.5 text-[#FFEA00]" />
            <span className="font-mono text-[10px] tracking-[0.25em] text-[#FFEA00] uppercase">{t("faq.eyebrow_pill")}</span>
          </div>
          <h2 data-testid="faq-heading" className="font-display font-bold text-white text-4xl md:text-6xl lg:text-7xl uppercase leading-none tracking-tight">
            {t("faq.heading_line1")} <span className="text-[#FFEA00]">{t("faq.heading_line2_accent")}</span>.
          </h2>
          <div className="mt-8 mx-auto w-32 h-1.5 hazard-stripes-anim" />
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
          {items.map((item, i) => (
            <FaqCard key={i} index={i + 1} q={item.q} a={item.a} />
          ))}
        </div>

        {onboarding && onboarding.steps && (
          <div data-testid="faq-onboarding" className="mt-8 border-2 border-[#FFEA00] bg-[#0F0F0F] p-6 md:p-8 shadow-[6px_6px_0_0_rgba(255,234,0,0.12)]">
            <h3 className="font-display font-bold text-white text-2xl md:text-3xl uppercase tracking-tight">{onboarding.title}</h3>
            <div className="mt-2 w-24 h-1 hazard-stripes-anim" />
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mt-6">
              {onboarding.steps.map((s, i) => (
                <div key={i} data-testid={`faq-onboarding-step-${i + 1}`} className="border-l-2 border-[#FFEA00] pl-4">
                  <div className="font-mono text-[11px] tracking-[0.25em] text-[#FFEA00] uppercase mb-2">{s.name}</div>
                  <p className="text-[#A3A3A3] text-sm leading-relaxed">{s.text}</p>
                </div>
              ))}
            </div>
          </div>
        )}
      </div>
    </section>
  );
};

const FaqCard = ({ index, q, a }) => {
  const idx = String(index).padStart(2, "0");
  return (
    <article data-testid={`faq-card-${index}`}
      className="relative bg-[#141414] border-2 border-[#222] border-l-4 border-l-[#FFEA00] hover:border-[#FFEA00] hover:bg-[#171717] transition-colors p-6 md:p-7">
      <div className="absolute -top-px -right-px w-2 h-2 bg-[#FFEA00]" />
      <div className="flex items-start gap-4">
        <span className="font-mono text-[11px] tracking-[0.25em] text-[#FFEA00] uppercase mt-1 shrink-0">Q · {idx}</span>
        <h3 className="font-display font-bold text-white text-lg md:text-xl uppercase leading-tight tracking-tight">{q}</h3>
      </div>
      <div className="mt-4 pl-[70px] md:pl-[76px] relative">
        <span aria-hidden="true" className="absolute left-[27px] md:left-[30px] top-0 bottom-0 w-px bg-[#FFEA00]/30" />
        <p className="font-sans text-[#D4D4D4] text-base leading-relaxed">{a}</p>
      </div>
    </article>
  );
};
